module.exports = __webpack_public_path__ + "img/bluesky09.ed2dd3c2.jpg";